import { isPdfHref } from './pdf'

/**
 * A Download button that asks for an email address before it hands the file
 * over.
 *
 * Asked for on 2026-08-30: *"customer success story'ler dışında siteden
 * indirilecek pdf'leri mailini almadan göstermiyoruz, mailine atıyoruz"*. So the
 * e-book and report Downloads no longer open the PDF — they scroll the reader to
 * the form at the foot of the page they are already on (`#contact`, the anchor
 * `ContactBand` carries), and the file they were after rides along on
 * `data-gated-download` so the thank-you panel can offer it once the form is in.
 * `ContactForm` picks that up with one delegated click listener, which is why no
 * page or section renderer has to know how the gate works.
 *
 * Spread it where `href` used to be: `<a {...gatedDownloadProps(pdf)}>`.
 *
 * **Only worth using where the page hydrates.** On an imported page there is no
 * client bundle, so the form at the bottom cannot accept a submission and a
 * gated link would be a Download button that never downloads. Those keep their
 * direct link.
 */
export function gatedDownloadProps(href: string): {
  href: string
  'data-gated-download'?: string
} {
  // Anything that is not a document — a landing page, an external link — is left
  // exactly as it was: there is nothing to gate and nothing to email.
  if (!isPdfHref(href)) return { href }
  return { href: '#contact', 'data-gated-download': href }
}
